// components/Header.js
import React from 'react';

const Header = ({ currentTime }) => {
  return (
    <header className="bg-gray-800 py-4 px-4 border-b border-gray-700">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-4">
          <h1 className="text-2xl font-bold text-purple-400">NetTV</h1>
          <span className="text-gray-400">Customer Service</span>
        </div>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <div className="status-online"></div>
            <span className="text-sm text-green-400">Online 24/7</span>
          </div>
          <div className="text-sm text-gray-400">
            {currentTime.toLocaleString('id-ID')}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;